@if (filters()) {
  <div class="mb-3 flex justify-between">
    <app-compact-filter [filters]="filters() ?? []" (filterChange)="applyFilter($event)" />
  </div>
}

<div>
  @if (metricsConfig(); as metricsConfig) {
    <app-metric-selector
      [data]="metricsConfig.data ?? {}"
      [previousPeriodData]="metricsConfig.previousData"
      (selectedMetricsChange)="selectMetrics($event)"
      [availableMetrics]="metricsConfig.metrics"
      [localStorageKey]="localStorageKey()"
    ></app-metric-selector>
  }
</div>

<div [class.hidden]="isGlobalChartHidden()" class="mt-3" *transloco="let t">
  <div iCard direction="vertical">
    <div class="flex items-center justify-between" iCardHeader>
      <div class="flex w-full items-center">
        @if (withEventAnnotation()) {
          <div class="mr-4 flex items-center gap-2">
            <IToggle
              [checked]="displayEventAnnotation()"
              (checkedChange)="toggleEventAnnotationDisplay($event)"
              [disabled]="disableEventAnnotation()"
            />
            <span class="events-toggle">{{ t("dashboard.activity_events") }}</span>
          </div>
          <app-activity-event-filters
            class="flex-1"
            [displayEventAnnotation]="displayEventAnnotation()"
            [disableEventAnnotation]="disableEventAnnotation()"
            [allEventAnnotationTypes]="allEventAnnotationTypes"
            [allStrategies]="(allStrategies$ | async) ?? []"
          />
        }
      </div>
      <div class="ml-3 flex items-center gap-x-3">
        @if (withDateAggregation()) {
          <IDateAggreationSwitchButton
            class="flex"
            [selected]="dateAggregation()"
            (dateAggSelected)="changeDateAggregation($event)"
          />
        }
        <button iButton variant="ghost" [iTooltip]="t('common.hide_chart')" (click)="toggleGlobalChartDisplay(true)">
          <IIcon name="close" />
        </button>
      </div>
    </div>
    <div iCardContent>
      @if (dataLoading()) {
        <div class="flex h-44 items-center justify-center">
          <ISpinner [display]="true" />
        </div>
      } @else {
        <IChart [config]="chartConfig()" [data]="chartData()" />
      }
    </div>
  </div>
</div>

<div class="my-3 flex justify-between" *transloco="let t">
  <button iButton variant="secondary" size="md" (click)="toggleParentAsin()">
    {{ isGroupByParent() ? t("product-tracker.split_by_child_asin") : t("product-tracker.group_by_parent_asin") }}
  </button>
  <div class="flex justify-end gap-1">
    <button
      iButton
      variant="secondary"
      size="md"
      [iTooltip]="t('common.restore_default_columns')"
      (click)="restoreDefaultColumns()"
    >
      {{ t("common.restore_columns") }}
    </button>
    <app-export-button tooltipValue="{{ t('common.export_as_csv') }}" (export)="onCsvExport()" />
    @if (isGlobalChartHidden()) {
      <button
        iButton
        variant="secondary"
        [iTooltip]="t('agency-board.show_global_chart')"
        (click)="toggleGlobalChartDisplay(false)"
      >
        <IIcon name="chartLine" />
      </button>
    }
  </div>
</div>

<div class="ag-theme-quartz grid">
  <ag-grid-angular
    style="width: 100%"
    class="h-[60vh]"
    #grid
    [columnDefs]="gridConfig().columnDefs"
    [rowData]="gridConfig().gridData"
    [gridOptions]="gridConfig().gridOptions"
    [animateRows]="true"
    (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
  />
</div>
